import { getStore } from '../../../init-store';
import { selectChatUserUid } from '../features/user/selectors';

/**
 * Uid для запросов чата с учётом подмены при `chatSubstitutedUid`.
 * Используется в мессенджер-виджете и при походах в api.messenger.yandex.ru.
 */
export function getChatUserUid() {
    const store = getStore();
    const state = store.getState();
    return selectChatUserUid(state);
}
